










































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import {ProfileState} from '@/store/modules/profile'
import Utils from '@/utils'

@Component({
  name: 'InputTimePicker',
  components: {
    SelectTag: Utils.loadComponent('proxy/Inputs/SelectTag'),
    TimePicker: Utils.loadComponent('proxy/Inputs/TimePicker'),
    TextField: Utils.loadComponent('proxy/Inputs/TextField'),
    AutoComplete: Utils.loadComponent('proxy/Inputs/AutoComplete'),
  },
})
export default class InputTimePicker extends Vue {

  public time?: string = ''
  public modal: boolean = false
  @State('profile') protected profileState!: ProfileState
  @State((state) => state.configuration.appConfig.time_slot_dimension) protected timeSlot!: any
  @State((state) => state.profile.materialTimePicker) protected materialTimePicker: boolean | undefined
  @Action('setTimePickerStyle') protected setTimePickerStyle!: any

  @Prop() private label!: string
  @Prop() private closeOnContentClick!: boolean
  @Prop() private lazy!: boolean
  @Prop() private disabled?: boolean
  @Prop() private fullWidth!: boolean
  @Prop() private allowedMinutes?: (m: string) => boolean
  @Prop() private allowedHours?: (m: string) => boolean
  @Prop() private min!: string
  @Prop() private max!: string
  @Prop() private rules!: any[]
  @Prop() private value?: string
  @Prop() private prependIcon?: string
  @Prop({
    type: String,
    default: '24hr',
  }) private format?: 'ampm' | '24hr'
  @Prop() private items!: string[]

  @Watch('value')
  protected valueChanged(): void {
    this.time = this.value
  }

  protected mounted() {
    if (this.materialTimePicker === undefined) {
      this.setTimePickerStyle(false)
    }
    this.time = this.value ? this.value : ''
  }

  protected get timeFormatted() {
    return this.time
  }

  protected save(time: string) {
    const dialog = (this.$refs.dialog as any)
    this.time = time
    if (dialog) {
      dialog.save(time)
      this.$emit('timeSelected', time)
    } else {
      this.$emit('timeSelected', time)
    }
  }
}
